import { createReduxModule } from "hooks-for-redux";
import { SharedPlayer } from "@chesshotel/types";

interface PlayersState {
  players: SharedPlayer[];
  search: string;
  lastUpdate: number;
}

const initialState: PlayersState = {
  players: [],
  search: "",
  lastUpdate: Date.now(),
};

const [
  usePlayers,
  {
    removePlayer,
    addPlayer,
    setPlayers,
    playersStartedPlaying,
    playersStoppedPlaying,
    setSearch,
  },
  playersStore,
] = createReduxModule("players", initialState, {
  removePlayer: (state: PlayersState, username: string): PlayersState => {
    return {
      ...state,
      players: state.players.filter((player) => player.u !== username),
    };
  },
  addPlayer: (state: PlayersState, player: SharedPlayer): PlayersState => {
    let notInList = true;
    for (let i = 0; i < state.players.length; i++) {
      const existingPlayer = state.players[i];
      if (existingPlayer.u === player.u) {
        notInList = false;
        break;
      }
    }

    if (notInList) {
      return {
        ...state,
        players: [...state.players, { ...player, p: false }],
      };
    } else {
      return state;
    }
  },
  setPlayers: (state: PlayersState, players: SharedPlayer[]): PlayersState => ({
    ...state,
    players,
  }),
  playersStartedPlaying: (
    state: PlayersState,
    { player1, player2 }: { player1: string; player2: string }
  ): PlayersState => {
    return {
      ...state,
      players: state.players.map((player) => {
        if (player.u === player1 || player.u === player2) {
          return { ...player, p: true };
        } else {
          return player;
        }
      }),
    };
  },
  playersStoppedPlaying: (
    state: PlayersState,
    {
      player1,
      player2,
      elo1,
      elo2,
    }: { player1: string; player2: string; elo1: number; elo2: number }
  ): PlayersState => {
    return {
      ...state,
      players: state.players.map((player) => {
        if (player.u === player1) {
          return { ...player, elo: elo1, p: false };
        } else if (player.u === player2) {
          return { ...player, elo: elo2, p: false };
        } else {
          return player;
        }
      }),
    };
  },
  setSearch: (state: PlayersState, search: string): PlayersState => ({
    ...state,
    search,
  }),
});

export {
  usePlayers,
  removePlayer,
  addPlayer,
  setPlayers,
  playersStartedPlaying,
  playersStoppedPlaying,
  setSearch,
  playersStore,
};
